<ng-container [ngSwitch]="enFileUploadMode">
  <!-- WEBCAM CAPTURE -->
  <ng-container *ngSwitchCase="'webcam'">
    <lib-cmp-webcam
      (dadosOut)="uploadFileFromWebcam($event)"
      (back)="onPreviewBack($event)"
    ></lib-cmp-webcam>
  </ng-container>

  <ng-container *ngSwitchDefault>
    <div class="upload-options" *ngIf="!isLoading">
      <div class="hud-botoes">
        <button
          mat-button
          class="custom-camera-button"
          (click)="onWebcamClick($event)"
          type="button"
        >
          <mat-icon>photo_camera</mat-icon>
          <span>Usar Câmera</span>
        </button>

        <input
          type="file"
          id="fileInput"
          (change)="onImgChange($event)"
          [accept]="acceptFiles"
          style="display: none"
        />
        <label for="fileInput" class="custom-file-upload">
          Escolher arquivo
        </label>
      </div>

      <div class="file-manager" *ngIf="show">
        <div class="filename" *ngIf="fileEvent">
          <mat-form-field appearance="outline" style="width: 60%">
            <mat-label>Nome do arquivo</mat-label>
            <input
              matInput
              #fileNameInput
              [formControl]="filenameControl"
              type="text"
              placeholder="Nome do arquivo"
              title="Use apenas letras, números, espaço, -, _, ., (, )"
              required
            />
            <mat-error *ngIf="filenameControl.hasError('required')">
              Campo obrigatório
            </mat-error>
            <mat-error *ngIf="filenameControl.hasError('pattern')">
              Use apenas letras, números, espaço, -, _, ., (, )
            </mat-error>
          </mat-form-field>
        </div>

        <div class="cropper-container">
          <div class="cropper" *ngIf="fileEvent" style="align-content: center">
            <image-cropper
              style="max-height: 630px; max-width: 680px"
              [imageChangedEvent]="fileEvent"
              [maintainAspectRatio]="true"
              [aspectRatio]="220 / 290"
              [resizeToWidth]="440"
              format="png"
              [backgroundColor]="backgroundColor"
              (imageLoaded)="showCropper()"
              (cropperReady)="invokeCropper()"
              (imageCropped)="imageCrop($event)"
              (loadImageFailed)="error()"
              [canvasRotation]="rotation"
            >
            </image-cropper>

            <div class="rotation-buttons">
              <button
                mat-icon-button
                class="btn-rotate"
                (click)="rotateLeft()"
                type="button"
              >
                <mat-icon>rotate_left</mat-icon>
              </button>

              <button
                mat-icon-button
                class="btn-rotate"
                (click)="rotateRight()"
                type="button"
              >
                <mat-icon>rotate_right</mat-icon>
              </button>
            </div>
          </div>

          <div class="previewImg" *ngIf="preview">
            <div class="previw">
              <p><strong>Pré-visualização da imagem cortada</strong></p>
              <img [src]="preview" width="220" />
            </div>

            <div class="hud-btns">
              <button
                class="btn-fechar btn-danger"
                mat-button
                (click)="onPreviewBack($event)"
                type="button"
              >
                <span>Cancelar</span>
              </button>

              <button
                class="btn-primary"
                mat-button
                (click)="onUploadClick()"
                type="submit"
              >
                <mat-icon>cloud_upload</mat-icon>
                <span>UPLOAD</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <mat-progress-bar
      mode="determinate"
      *ngIf="fileToUpload && progress > 0 && progress <= 100"
      [value]="progress"
    >
    </mat-progress-bar>

    <ui-loading [isLoading]="isLoading"></ui-loading>
  </ng-container>
</ng-container>
